import { render, staticRenderFns } from "./product-material.vue?vue&type=template&id=4158e9a8&scoped=true"
import script from "./product-material.vue?vue&type=script&lang=ts"
export * from "./product-material.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158e9a8",
  null
  
)

export default component.exports